import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  IconButton,
  Input,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from '@mui/material';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import MainContainer from '../../layout/MainContainer';
import { VEHICLE_TYPE } from '../../utils/enums';

const AddTechnicalFeatures = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [image, setImage] = useState('');
  const [vehicleType, setVehicleType] = useState<any>('default');

  const handleVehicleType = (event: SelectChangeEvent) => {
    setVehicleType(event.target.value as any);
  };

  const handleImageUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    if (!file) {
      setImage('');
      return;
    }

    // Generate a temporary URL for preview
    const imageUrl = URL.createObjectURL(file);
    setImage(imageUrl);
  };

  return (
    <MainContainer>
      <div className="main_title fdx">
        <div>
          <h1>{id ? 'Edit' : 'Add'} Technical Feature</h1>
          <p>
            <span onClick={() => navigate('/dashboard')}>Dashboard</span> -{' '}
            <span onClick={() => navigate('/vehicle-specifications/technical-features')}>
              Vehicle Specifications
            </span>{' '}
            -{' '}
            <span onClick={() => navigate('/vehicle-specifications/technical-features')}>
              Technical Features
            </span>{' '}
            - {id ? 'Edit' : 'Add'}
          </p>
        </div>
        <div className="right_s align_right">
          <Button className="btn btn_orange" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>

      <div className="cards">
        <form className="form" action="">
          <div className="gap_p">
            <div className="control_group w_50">
              <label>Technical Feature Image</label>
              <div className="upload_box">
                <label>
                  {image && (
                    <IconButton className="crossIcon" onClick={() => setImage('')}>
                      <CloseIcon />
                    </IconButton>
                  )}
                  <figure>
                    <img src={image ? image : '/static/images/picture.png'} alt="Upload" />
                  </figure>
                  <IconButton className="uploadIcon">
                    <label htmlFor="icon-button-file">
                      <Button component="span" className="upload_image_btn">
                        <img src="/static/images/edit2_icon.svg" alt="Upload" />
                        <Input
                          sx={{ display: 'none' }}
                          id="icon-button-file"
                          type="file"
                          inputProps={{
                            accept: 'image/png,image/jpeg',
                          }}
                          onChange={(e: any) => {
                            handleImageUpload(e);
                            e.target.value = null;
                          }}
                        />
                      </Button>
                    </label>
                  </IconButton>
                </label>
              </div>
            </div>
            <div className="control_group w_50" />
            <div className="control_group w_50">
              <label>Select Vehicle Type</label>
              <Select
                fullWidth
                labelId="vehicleType"
                id="vehicleType"
                value={vehicleType}
                onChange={handleVehicleType}
              >
                <MenuItem disabled value="default">
                  Select Vehicle Type
                </MenuItem>
                <MenuItem value={VEHICLE_TYPE.CAR}>Car</MenuItem>
                <MenuItem value={VEHICLE_TYPE.BIKE}>Bike</MenuItem>
                <MenuItem value={VEHICLE_TYPE.TRUCK}>Truck</MenuItem>
                <MenuItem value={VEHICLE_TYPE.HEAVY_VEHICLE}>Heavy Vehicle</MenuItem>
              </Select>
            </div>
            <div className="control_group w_50">
              <label>Technical Feature Name</label>
              <TextField
                variant="outlined"
                placeholder="Technical Feature Name"
                fullWidth
                hiddenLabel
                // value={fullName}
                // onChange={(e) => setFullName(e.target.value)}
              />
              {/* {error && fullName == "" ? (
                <h6 className="err_msg">Name is required</h6>
              ) : (
                ""
              )} */}
            </div>
          </div>

          <div className="form_end_btn">
            <Button
              className="btn btn_secondary"
              onClick={() => navigate('/vehicle-specifications/technical-features')}
            >
              Submit
            </Button>
          </div>
        </form>
      </div>
    </MainContainer>
  );
};

export default AddTechnicalFeatures;
